import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';

// Context
import ApproachContext from '../../../../context/ApproachContext';

// PropTypes
import { companyPropTypes } from '../../../../proptypes/companyProptypes';

// Components
import Button from '../../../shared/Button';

// Styles
import styles from './notForYouSection.module.scss';

const NotForYouSection = ({
  company,
  companyColor,
  isJobClosed,
  onJobShare,
}) => {
  const approach = useContext(ApproachContext);
  const { t } = useTranslation('common');

  return (
    <section id="not-for-you-section" className={styles.container}>
      <div className={styles.line}>
        <h2 className={styles.heading}>
          {t(`description_page.not_for_you_section.title.${approach}`)}
        </h2>

        <p className={styles.description}>
          {t(`description_page.not_for_you_section.description.${approach}`)}
        </p>

        <div className={styles.shareJob}>
          <div className={styles.button} data-tip data-for="cta-disabled">
            <Button
              style={{
                border: `2px solid ${companyColor} !important`,
                color: `${company.color} !important`,
              }}
              type="default"
              disabled={isJobClosed}
              onClick={onJobShare}
            >
              {t(`description_page.main_section.cta_btn_share.${approach}`)}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

NotForYouSection.propTypes = {
  company: PropTypes.shape(companyPropTypes).isRequired,
  companyColor: PropTypes.string.isRequired,
  isJobClosed: PropTypes.bool.isRequired,
  onJobShare: PropTypes.func.isRequired,
};

export default NotForYouSection;
